export default class ThemeState {
  logoSrc = String;
  noteInsertGifSrc = String;
}
